import React from 'react';
import { Processor } from '../../types/dashboard';
import { Trophy, Medal, Star, Flame } from 'lucide-react';
interface PerformanceLeaderboardProps {
  processors: Processor[];
}
export function PerformanceLeaderboard({
  processors
}: PerformanceLeaderboardProps) {
  // Sort by efficiency for leaderboard
  const sortedProcessors = [...processors].sort((a, b) => b.efficiency - a.efficiency).slice(0, 5);
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-113">
      <div className="p-5 border-b border-slate-100 bg-gradient-to-r from-indigo-600 to-purple-600 text-white" data-id="element-114">
        <h3 className="font-bold flex items-center gap-2" data-id="element-115">
          <Trophy className="w-5 h-5 text-yellow-300" data-id="element-116" />
          Top Performers
        </h3>
        <p className="text-indigo-100 text-xs mt-1" data-id="element-117">
          Based on efficiency & volume
        </p>
      </div>

      <div className="divide-y divide-slate-100" data-id="element-118">
        {sortedProcessors.map((processor, index) => <div key={processor.id} className="p-4 flex items-center gap-4 hover:bg-slate-50 transition-colors" data-id="element-119">
            <div className="flex-shrink-0 w-8 font-bold text-slate-400 text-center" data-id="element-120">
              {index === 0 && <Medal className="w-6 h-6 text-yellow-500 mx-auto" data-id="element-121" />}
              {index === 1 && <Medal className="w-6 h-6 text-slate-400 mx-auto" data-id="element-122" />}
              {index === 2 && <Medal className="w-6 h-6 text-amber-700 mx-auto" data-id="element-123" />}
              {index > 2 && <span className="text-lg" data-id="element-124">#{index + 1}</span>}
            </div>

            <img src={processor.avatar} alt={processor.name} className="w-10 h-10 rounded-full border border-slate-200" data-id="element-125" />

            <div className="flex-1" data-id="element-126">
              <h4 className="font-bold text-slate-900 text-sm" data-id="element-127">
                {processor.name}
              </h4>
              <div className="flex items-center gap-2 text-xs text-slate-500" data-id="element-128">
                <span data-id="element-129">{processor.activeLoans} Active Loans</span>
                <span data-id="element-130">•</span>
                <span className="flex items-center gap-1 text-indigo-600 font-medium" data-id="element-131">
                  <Flame className="w-3 h-3" data-id="element-132" />
                  {processor.efficiency}% Eff.
                </span>
              </div>
            </div>

            {index === 0 && <div className="bg-yellow-100 text-yellow-700 p-1.5 rounded-full" data-id="element-133">
                <Star className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-134" />
              </div>}
          </div>)}
      </div>
    </div>;
}